import authService from '../abs/services/auth/authService';

/**
 * 这个工具主要的是处理统计的方法
 */
export default class StatisticsUtil {
  private static _czc: any[] = [];

  private static isInit = false;

  private static dispatch: any = null;

  static init() {
    if (this.isInit) {
      this._czc = [];
      // 删除脚本
      // tslint:disable-next-line: no-shadowed-variable
      const rootS: HTMLScriptElement = document.getElementsByTagName('script')[0];
      const rootSrc = 'https://c.cnzz.com/core.php?web_id=1278942661&t=z';
      if (rootS && rootSrc === rootS.src) {
        rootS.remove();
      }
      const node = document.getElementById('cnzz');
      if (node) {
        node.remove();
      }
    }
    // 创建脚本
    const cnzzSTag = document.createElement('script');
    cnzzSTag.type = 'text/javascript';
    cnzzSTag.id = 'cnzz';
    cnzzSTag.async = true;
    cnzzSTag.charset = 'utf-8';
    cnzzSTag.src = 'https://v1.cnzz.com/z_stat.php?id=1278942661&web_id=1278942661';
    const rootS: HTMLScriptElement = document.getElementsByTagName('script')[0];
    if (rootS && rootS.parentNode) {
      rootS.parentNode.insertBefore(cnzzSTag, rootS);
    }
    // 设置账号信息
    this._czc.push(['_setAccount', '1278942661']);
    this._czc.push(['_setAutoPageview', false]);
    // 判断是否是付费用户
    const user = authService.getCurrentUser();
    // 用户名 CNABS_PassCode
    const name = StatisticsUtil.getCookie('CNABS_PassCode') || '未登录';
    const isPay = user ? (user.isPayed ? '付费' : '未付费') : '未登录';
    this._czc.push(['_setCustomVar', '用户名', name]);
    this._czc.push(['_setCustomVar', '是否付费', isPay]);
    this.isInit = true;
  }

  /**
   * 统计所有的路径信息
   */
  static statisticsRoutes() {
    StatisticsUtil.init();
    const { href, hash, pathname } = window.location;
    const [host] = href.split('#');
    this._czc.push(['_trackPageview', `${pathname}${hash}`, `${host}`]);
    // tslint:disable-next-line: no-string-literal
    window['_czc'] = this._czc;
  }

  /**
   * 设置缓存
   * @param name
   */
  static getCookie(name: string) {
    let arr,
      reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    if ((arr = document.cookie.match(reg))) {
      return unescape(arr[2]);
    }
    return null;
  }

  /**
   * 统计情景的信息
   * @param msciName
   */
  static statisticsScenario(scenarioId: number, scenarioName: string, shortName: string, dealId: string) {
    StatisticsUtil.init();
    const { href, hash, pathname } = window.location;
    const [host] = href.split('#');
    const scenario = scenarioName.replace(/\s+/g, '');
    const data = hash.indexOf('?deal_id=') > -1 ? '' : '?deal_id=' + dealId;
    this._czc.push(['_trackPageview', `${pathname}${hash}${data}&scenario_id=${scenarioId}&scenario=${scenario}&deal=${shortName}`, `${host}`]);
    // tslint:disable-next-line: no-string-literal
    window['_czc'] = this._czc;
  }

  /**
   * 统计ELK的信息
   * @param urlParam
   */
  static statisticsELK(urlParam?: string) {
    const isLogin = authService.checkIsLogin();
    if (isLogin) {
      const url = urlParam || window.location.pathname + '/' + window.location.hash;
      if (url.indexOf('/callback') === -1) {
        this.dispatch({
          type: 'global/pageLog',
          payload: {
            url: url,
            title: document.title
          }
        });
      }
    }
  }

  /**
   *  设置dispatch
   * @param dispatch
   */
  static setDispatch(dispatch: any, urlParam?: string) {
    this.dispatch = dispatch;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/statisticsUtil.ts